import { IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import { IDatasource } from 'utility-ts-orm';
import { Schedule } from '../builders/schedule_builder';
import { ScheduleSection } from '../builders/schedule_section_builder';
import { ScheduleTerm } from '../builders/schedule_terms_builder';
import { ScheduleQuery } from '../queries/schedule_query';

angular
  .module('capability-ng-course-schedule')
  .factory(
    'courseListCommand',
    function courseListCommandDefinition(
      $q: ng.IQService,
      $http: ng.IHttpService,
      ngScheduleSectionDatastore: IDatasource<ScheduleSection>,
      ngScheduleTermsDatastore: IDatasource<ScheduleTerm>,
      ngScheduleDatastore: IDatasource<Schedule>,
      ngScheduleQuery: ScheduleQuery,
      defineCommand: IDefineCommand,
      QueryMediator: IQueryMediator,
      ngSchedulePriorityFeedQuery: IQuery
    ) {
      return defineCommand('courseListCommand', function courseListCommand(deferred: ng.IDeferred<Schedule>) {
        $http
          .get('reg/dashboard/courses/')
          .then((res: any) => {
            ngScheduleDatastore.write([res.data]);
            ngScheduleQuery.run();
            const { section, term }: { section: ScheduleSection[]; term: ScheduleTerm[] } = ngScheduleQuery.model;
            ngScheduleSectionDatastore.write(section);
            ngScheduleTermsDatastore.write(term);
            ngSchedulePriorityFeedQuery.run();
            deferred.resolve(ngScheduleQuery.model);
          })
          .catch((err: any) => {
            deferred.reject(err);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/commands/load_course_list_command.ts